import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Oxanium\",\"arguments\":[{\"weight\":[\"500\",\"600\",\"700\",\"800\"],\"subsets\":[\"latin\"],\"variable\":\"--font-oxanium\",\"display\":\"swap\"}],\"variableName\":\"oxanium\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/AdsBoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/AdSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdsterraConsentProvider","AdsterraSocialBar"] */ "/vercel/path0/src/components/adsterra/AdsterraAds.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/chrome/Header/Header.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/chrome/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/chrome/Header/HeaderInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/chrome/Header/HeaderMobileBackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/functions/SWRegister/SWRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/gam/GamWebInterstitial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/gam/GptBoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/interstitial/InterstitialProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/Page/Page.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/SectionHeader/SectionHeader.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/Container/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/navigation/JourneyBaseNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/navigation/RouteScrollReset/RouteScrollReset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/privacy/PrivacyChoices.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/main.css");
